import { EffectCallback, useEffect, useRef } from "react";

/**
 * Allow to listen to an event of window and execute a callback, with the default option to execute the callback immediately
 * Stop listening when the component is unmounted
 * @param event event 
 * @param callback 
 * @param dependants 
 * @param immediate 
 * @returns 
 */
export const useListenCallback = (event: string, callback: EventListener, dependants?: readonly unknown[], immediate: boolean = true): EffectCallback => {
    const unsubscribe = useRef<EffectCallback>(() => {});
    useEffect(() => {
        const unsubscribeController = new AbortController();
        window.addEventListener(event, callback, { signal: unsubscribeController.signal });
        immediate && (callback as Function)();
        unsubscribe.current = () => unsubscribeController.abort();
        return () => unsubscribeController.abort();
    }, [event, callback, immediate, ...(dependants || [])]);
    return unsubscribe.current;
}